import { Stack, Typography, styled } from '@mui/material';
import { useAtom } from 'jotai';
import Image, { ImageProps } from 'next/image';
import { ReactNode } from 'react';
import { StyledButton } from '../../../../../ui';
import { communityAtom } from '../../../../atoms/community.atom';

const StyledContainer = styled(Stack)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
`;
const ShortDescriptionText = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-size: 20px !important;
  font-style: italic;
  font-weight: 500;
  line-height: 32px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #ffffffcc;
  & > p {
    font-family: var(--font-work-sans), sans-serif;
    font-size: 20px !important;
    font-style: italic;
    font-weight: 500;
    line-height: 32px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #ffffffcc;
  }
` as typeof Typography;

const HostNameText = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 23.46px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #ffffffcc;
`;
const HostDescriptionText = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 18.77px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #ffffffcc;
`;
const HostCardOuterStack = styled(Stack)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
  }
`;

const HostCardInnerStack = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 0px;
  }
`;

const HostCardTextStack = styled(Stack)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

const HostImage = styled(Image)`
  border-radius: 50%;
`;

const ReadMoreButtonWrapper = styled('div')`
  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-top: 12px;
  }
`;

export function HostCard({
  host,
  profileImageProps,
  hostDescription,
}: Pick<MomentsStepsProps, 'host' | 'profileImageProps' | 'hostDescription'>) {
  return (
    <HostCardInnerStack>
      <HostImage width={52} height={52} {...profileImageProps} alt={profileImageProps.alt || ''} />
      <HostCardTextStack>
        <HostNameText>{host}</HostNameText>
        <HostDescriptionText>{hostDescription}</HostDescriptionText>
      </HostCardTextStack>
    </HostCardInnerStack>
  );
}

interface MomentsStepsProps {
  shortDescription: ReactNode;
  host: ReactNode;
  profileImageProps: ImageProps;
  hostDescription: ReactNode;
  index: number;
}

export default function MomentsSteps({
  shortDescription,
  host,
  profileImageProps,
  hostDescription,
  index,
}: MomentsStepsProps) {
  const [, setCommunity] = useAtom(communityAtom);
  return (
    <StyledContainer>
      <ShortDescriptionText component="div">{shortDescription}</ShortDescriptionText>
      <HostCardOuterStack>
        <HostCard
          host={host}
          profileImageProps={profileImageProps}
          hostDescription={hostDescription}
        />
        <ReadMoreButtonWrapper>
          <StyledButton
            onClick={() => {
              setCommunity({ openIndex: index });
            }}
          >
            Read More
          </StyledButton>
        </ReadMoreButtonWrapper>
      </HostCardOuterStack>
    </StyledContainer>
  );
}
